import { Navigation } from "swiper";
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Loader, Modal, Placeholder } from "rsuite";
import InfoRoundIcon from "@rsuite/icons/InfoRound";
import ArrowLeftLineIcon from "@rsuite/icons/ArrowLeftLine";

import Meals from "../elements/meals/meals";
import Buttons from "../elements/dynamic/buttons/Buttons";

import { sync } from "./sync";
import { DownloadPdf } from "./DownloadPdf";
import { deleteFasting } from "./deleteFasting";

import "swiper/css";
import "./userMeal.scss";
import "swiper/css/navigation";
import "react-toastify/dist/ReactToastify.css";

const UserMeal = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [activeDate, setActiveDate] = useState(null);
  const [todayIndex, setTodayIndex] = useState(0);
  const [activeDateContent, setActiveDateContent] = useState(null);
  const { subscriptionId, periodId } = props;
  const [isExpired, setIsExpired] = useState(false);
  const [swiper, swiperSet] = useState(null);

  const [buttons, setButtons] = useState(null);
  const [showCalorieStatus, setShowCalorieStatus] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [modalView, setModalView] = useState(null);

  useEffect(() => {
    localStorage.setItem("activeIndex", "");
    sync({
      handleNotfound,
      subscriptionId,
      periodId,
      setIsLoading,
      setData,
      setButtons,
      setIsExpired,
      setActiveDateContent,
      setShowCalorieStatus,
      setTodayIndex,
      setActiveDate,
      showGuideModal,
      todayIndex,
    });
  }, []);

  const handleClose = () => {
    setOpenModal(false);
  };

  const getBody = (body) => {
    if (body.type === "text") {
      const date = ` ${activeDateContent?.date?.day_number}  ${activeDateContent?.date?.month_title} ${activeDateContent?.date?.year_number} `;
      const text = body.content.text.replace("[date]", date);

      return <div style={body?.content?.style}>{text}</div>;
    }
    if (body.type === "list") {
      return body.content.map((item) => {
        return (
          <div
            className={"d-flex justify-content-start"}
            style={item?.style ?? ""}
          >
            {item?.icon?.position === "start" && (
              <div style={item?.icon?.style}>
                <img src={item?.icon?.image} alt={`icon`} />
              </div>
            )}
            {item?.text && <div className={""}>{item.text}</div>}
            {item?.icon?.position === "end" && (
              <div>
                <img src={item?.icon?.image} alt={`icon`} />
              </div>
            )}
          </div>
        );
      });
    }
  };

  const handleModalContent = (content) => {
    const header = (
      <div
        className={" modal-header "}
        id={content.id}
        style={content?.title?.style}
      >
        {content?.title?.text}
      </div>
    );

    const body = (
      <div
        className={" modal-body "}
        id={content.id}
        style={content?.body?.style}
      >
        {content?.body && getBody(content?.body)}
      </div>
    );

    const footer = content?.body?.buttons && (
      <div className={"modal-footer"}>
        <Buttons
          buttons={content?.body?.buttons}
          handleButtonClick={handleButtonClick}
          buttonContainerClass={
            "flex-row justify-content-center align-items-start"
          }
          buttonContainerStyles={{ gap: "8px" }}
        />
      </div>
    );

    setModalView({ header: header, body: body, footer: footer });
    setOpenModal(true);
  };

  function changeDay(dayIndex) {
    setIsLoading(true);
    setActiveDate(dayIndex);
    setActiveDateContent(data.day_meals[dayIndex]);
    localStorage.setItem("activeIndex", JSON.stringify(dayIndex));
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    if (dayIndex === todayIndex) {
      swiper.slideTo(dayIndex);
    }
  }

  const showGuideModal = (subscriptionId, content) => {
    let showGuideSubscriptionId = localStorage.getItem(
      "show_guide_subscription_id"
    );
    if (
      !showGuideSubscriptionId ||
      showGuideSubscriptionId !== subscriptionId
    ) {
      handleButtonClick({ type: "popup" }, content);
      localStorage.setItem("show_guide_subscription_id", subscriptionId);
    }
  };

  function handleNotfound() {
    localStorage.setItem("error", "PageNotFound");
    setIsLoading(false);
    window.location.href = "";
  }

  const handleButtonClick = (target, content) => {
    switch (target?.type) {
      case "popup":
        handleModalContent(content);
        break;
      case "submit":
        deleteFasting({
          handleNotfound,
          subscriptionId,
          periodId,
          setIsLoading,
          setData,
          setButtons,
          setIsExpired,
          setActiveDateContent,
          setShowCalorieStatus,
          setTodayIndex,
          setActiveDate,
          showGuideModal,
          todayIndex,
          url: target?.value,
          activeDateContent,
          setOpenModal,
        });
        break;
      case "cancel":
        setOpenModal(false);
        break;
      default:
        break;
    }
  };

  function render() {
    if (data.length === 0) {
      return (
        <div className="empty-data">
          <Placeholder.Paragraph rows={8} />
          <Loader
            backdrop
            content="سیستم درحال پردازش اطلاعات شما میباشد ..."
            vertical
          />
        </div>
      );
    }

    if (data.day_meals.length === 0) {
      window.location.replace("/subscriptions");
      return <></>;
    }

    return (
      <>
        <div className="dates">
          <Swiper
            spaceBetween={0}
            slidesPerView={4}
            navigation={true}
            initialSlide={activeDate ? activeDate : 0}
            modules={[Navigation]}
            onSwiper={(swiper) => swiperSet(swiper)}
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 4,
              },
              1024: {
                slidesPerView: 7,
              },
            }}
          >
            {data.day_meals.map((dayMeal, dayMealIndex) => (
              <SwiperSlide key={dayMealIndex}>
                {dayMeal?.label && (
                  <span className="d-flex top-badge-danger">
                    {dayMeal?.label}
                  </span>
                )}
                <div
                  onClick={(e) => changeDay(dayMealIndex)}
                  className={`day ${
                    dayMealIndex === activeDate ? "day-active" : ""
                  }`}
                >
                  <div className="day-container">
                    <div className="day-title">{dayMeal.date.day_title}</div>
                    <div className="day-number">
                      <div className="month-title">{dayMeal.date.md}</div>
                    </div>
                  </div>
                  {dayMeal.trial ? <div className="day-trial"></div> : ""}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="meal-content">
          <div className="d-block text-right" style={{ marginBottom: "1rem" }}>
            <div className="meals-title d-flex flex-row justify-content-between ">
              <div className="text-bold d-inline meals-day">
                <span style={{ paddingLeft: "5px" }}> وعده های </span>
                <span
                  style={{
                    paddingLeft: "5px",
                    display:
                      activeDateContent.date.md === "امروز" ? "none" : "unset",
                  }}
                >
                  {activeDateContent.date.day_title}
                </span>{" "}
                {activeDateContent.date.md}
              </div>
              {activeDate !== todayIndex ? (
                <button
                  onClick={(e) => changeDay(todayIndex)}
                  className="btn-today"
                >
                  مشاهده امروز
                  <ArrowLeftLineIcon />
                </button>
              ) : (
                ""
              )}

              {buttons && activeDateContent?.label === "فستینگ" && (
                <div className="text-bold d-inline meals-buttons justify-content-end">
                  <Buttons
                    buttons={buttons}
                    setOpenModal={setOpenModal}
                    handleButtonClick={handleButtonClick}
                    buttonContainerClass={"align-items-end justify-content-end"}
                  />
                  <div className={"modal"}>
                    <Modal
                      open={openModal}
                      onClose={handleClose}
                      keyboard={true}
                    >
                      <Modal.Header
                        className="mt-1"
                        style={{ marginTop: "1rem" }}
                      >
                        {modalView?.header}
                      </Modal.Header>
                      <div className="mt-1">{modalView?.body}</div>
                      {modalView?.footer && (
                        <Modal.Footer className="mt-2 d-flex justify-content-center">
                          {modalView?.footer}
                        </Modal.Footer>
                      )}
                    </Modal>
                  </div>
                </div>
              )}
            </div>

            {showCalorieStatus?.calorie === 1 &&
            activeDateContent &&
            activeDateContent.calorie > 0 ? (
              <div className="d-flex d-block-on-mobile mt-10px">
                <div
                  className="w-50 text-start w-100-on-mobile"
                  style={{ fontSize: "1rem", textAlign: "start" }}
                >
                  <div className="total-calories">
                    <InfoRoundIcon />
                    مجموع کالری دریافتی روزانه:
                    <strong>{activeDateContent.calorie} کالری</strong>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

          {isLoading ? (
            <Loader style={{ marginTop: "2rem" }} size="sm" content="" />
          ) : (
            <Meals
              mealsItems={
                activeDateContent.trial
                  ? data.day_meals[0].meals
                  : activeDateContent.meals
              }
              isExpired={isExpired}
              data={data}
              activeDate={activeDate}
              sync={() =>
                sync({
                  handleNotfound,
                  subscriptionId,
                  periodId,
                  setIsLoading,
                  setData,
                  setButtons,
                  setIsExpired,
                  setActiveDateContent,
                  setShowCalorieStatus,
                  setTodayIndex,
                  setActiveDate,
                  showGuideModal,
                  todayIndex,
                })
              }
              trial={activeDateContent.trial}
              changeDay={changeDay}
              showCalorieStatus={showCalorieStatus}
            />
          )}
        </div>

        <DownloadPdf />
      </>
    );
  }

  return (
    <>
      <div className="d-flex">
        <div
          className="w-50 text-bold text-start"
          style={{ fontSize: "1rem", textAlign: "start" }}
        >
          برنامه غذایی این دوره
        </div>
      </div>

      <div className="user-meals dates-container" style={{ marginTop: "2rem" }}>
        <div className="dates"></div>

        <div className="date-content">
          <div className="card">
            {data ? (
              render()
            ) : (
              <Loader backdrop content="درحال دریافت اطلاعات ..." vertical />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UserMeal;
